import type { RouteObject } from 'react-router-dom';
import type { RouteConfig } from '@/router/route.types';
import { WrapperLoading } from '@/router/WrapperLoading';

export const createRoute = ({ component: Component, ...config }: RouteConfig): RouteObject => ({
  ...config,
  element: (
    <WrapperLoading>
      <Component />
    </WrapperLoading>
  ),
});
